module.exports = __webpack_public_path__ + "static/header-poster-92a09657961ba58cfa896dda38d28451.jpg";